<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div v-if="gw_url">
                    <div v-if="paymentState === 'CREATED'">
                        Platba ještě nebyla zaplacena
                    </div>
                    <div v-else-if="paymentState === 'PAYMENT_METHOD_CHOSEN'">
                        Platební metoda vybrána
                    </div>
                    <div v-else-if="paymentState === 'PAID'">
                        Platba proběhla úspěšně
                    </div>
                    <div v-else-if="paymentState === 'CANCELED'">
                        Platba byla zrušena
                    </div>
                    <div v-else-if="paymentState === 'TIMEOUTED'">
                        Platba nebyla zaplacena v časovém limitu
                    </div>
                    <div v-else-if="paymentState === 'REFUNDED'">
                        Platba refundována
                    </div>
                    <div v-else-if="paymentState === 'PARTIALLY_REFUNDED'">
                        Platba částečně refundována
                    </div>
                    <div v-else-if="paymentState === 'AUTHORIZED'">
                        Platba předautorizována
                    </div>
                    <div v-else>
                        Nyní můžete zaplatit Vaši objednávku služeb
                    </div>
                </div>
                <div v-else>
                    Načítám platební bránu..
                </div>

                <div class="row mt-5">
                    <div class="col-6 col-sm-10">
                        <a :href="linkToSS" class="button-02">
                            Pokračovat
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FormWizardFirmGopay',
    data() {
        return {
            paid: false,
        }
    },
    computed: {
        gw_url() {
            return this.$store.state.gopay.payment.gw_url
        },
        linkToSS() {
            return `http://scripts.ci.cz/toSS.php?web=ceskestavby&fid=${this.$store.state.firm.result.id_firmy}&ftoken=${this.$store.state.firm.result.opravny_kod}`
        },
        paymentState() {
            return this.$store.state.gopay.payment_state
        },
        sandbox() {
            return this.$store.state.config.sandbox
        },
    },
    mounted() {
        // const plugin = document.createElement('script')
        // if (this.sandbox) {
        //     plugin.setAttribute(
        //         'src',
        //         'https://gw.sandbox.gopay.com/gp-gw/js/embed.js'
        //     )
        // } else {
        //     plugin.setAttribute(
        //         'src',
        //         'https://gate.gopay.cz/gp-gw/js/embed.js'
        //     )
        // }
        // plugin.async = true
        // document.head.appendChild(plugin)

        this.showGopayGW()
    },
    methods: {
        showGopayGW() {
            this.$store.dispatch(
                'loader/setLoader',
                'Načítám autoriční údaje ...',
                { root: true }
            )
            this.$store
                .dispatch('gopay/getToken')
                .then(() => {
                    /*
                let gopayScript = document.createElement('script')
                gopayScript.setAttribute('src', 'https://gw.sandbox.gopay.com/gw/v3/dfgvmwTKK5hrJx2aGG8ZnFyBJhAvF')
                document.head.appendChild(gopayScript)

                 */
                    this.$store.dispatch(
                        'loader/setLoader',
                        'Vytvářím platbu Gopay ...'
                    )

                    this.$store.dispatch('gopay/createPayment').then(status => {
                        if (!status) {
                            this.$store.dispatch(
                                'loader/setError',
                                'Nepodařilo se vytvořit Gopay platbu, platba bude fakturou'
                            )
                            // pri chybe brany nebude platba kartou, ale fakturou
                            this.$store.commit('firm/setOrderOptions', {
                                payment_method: 1,
                            })
                            this.$store
                                .dispatch('gopay/changePaymentMethod')
                                .then(status => {
                                    if (!status) {
                                        this.$store.dispatch(
                                            'loader/setLoader',
                                            'Nepodařilo se změnit platební metodu na fakturu'
                                        )
                                    }
                                })
                            return
                        }

                        this.$store.dispatch(
                            'loader/setLoader',
                            'Načítám platební bránu'
                        )
                        /*
                        let gw = document.createElement('script')
                        gw.setAttribute(
                            'src',
                            'https://gw.sandbox.gopay.com/gp-gw/js/embed.js'
                        )
                        document.head.appendChild(gw)
*/
                        let vm = this
                        _gopay.checkout(
                            { gatewayUrl: this.gw_url, inline: true },
                            function(checkoutResult) {
                                console.log('checkoutResult', checkoutResult)
                                const { id, url } = checkoutResult
                                vm.$store.dispatch(
                                    'loader/setLoader',
                                    'Kontroluji stav platby ' + id + ' ...'
                                )
                                vm.$store
                                    .dispatch('gopay/getState')
                                    .then(paymentState => {
                                        console.log(
                                            'paymentState',
                                            paymentState
                                        )

                                        if (paymentState === 'PAID') {
                                            vm.$store.dispatch(
                                                'loader/setLoader',
                                                ''
                                            )
                                            // zapisu do store a CRM
                                            vm.$store.dispatch(
                                                'gopay/changePaymentStatus',
                                                paymentState
                                            )
                                        } else {
                                            // pri chybe brany nebude platba kartou, ale fakturou
                                            vm.$store.commit(
                                                'firm/setOrderOptions',
                                                {
                                                    payment_method: 1,
                                                }
                                            )
                                            vm.$store
                                                .dispatch(
                                                    'gopay/changePaymentMethod'
                                                )
                                                .then(
                                                    vm.$store.dispatch(
                                                        'loader/setError',
                                                        'Platba bude proforma fakturou'
                                                    )
                                                )
                                                .catch(() => {
                                                    vm.$store.dispatch(
                                                        'loader/setLoader',
                                                        'Nepodařilo se změnit platební metodu na fakturu'
                                                    )
                                                })
                                        }
                                        console.log(
                                            'todo zobrazit hlasku o provedeni platby'
                                        )
                                    })
                                    .catch(error => {
                                        console.log(error)
                                        vm.$store.dispatch(
                                            'loader/setError',
                                            'Chyba ověření stavu platby ' + id
                                        )
                                    })

                                //uzavreni embedu muzeme odchytavat callbackem
                                //callbacku je pri uzavreni predavan objekt checkoutResult, ktery obsahuje vlastnost id a url (return-url)
                                //!! je nutne pocitat i s variantou navratu z platebniho procesu na returnURL!! (platebni tlacitka)

                                //dalsim volanim dotazujeme stav platby a zobrazujeme vysledek
                            }
                        )

                        this.$store.dispatch('loader/setLoader', '')
                    })
                })
                .catch(() => {
                    this.$store.dispatch(
                        'loader/setError',
                        'Chyba autentizace platební brány'
                    )

                    // pri chybe brany nebude platba kartou, ale fakturou
                    this.$store
                        .dispatch('gopay/changePaymentMethod')
                        .then(
                            vm.$store.dispatch(
                                'loader/setError',
                                'Platba bude proforma fakturou'
                            )
                        )
                        .catch(() => {
                            this.$store.dispatch(
                                'loader/setLoader',
                                'Nepodařilo se změnit platební metodu na fakturu'
                            )
                        })
                })

            // this.$store.dispatch('loader/setLoader', '')
        },
    },
}
</script>
